import {Permission} from '../types';

export interface IClientDetail {
  clientListProperties: {
    key: string;
    value: string;
    displayExpandCollapseButton?: boolean;
    clientPermInfo?: {
      name?: string;
      description?: string;
    };
  }[];
  clientName: string; // client name
  isAdmin: boolean; // admin status
  createdBy: string; //created by name
  createdDate: Date; //created on date
  updatedBy: string; //updated by name
  updatedDate: Date; //updated on date
  isExpanded: boolean; //list expanded status
  id: number;
  clientId?: string;
}

/**
 * Create new interface to fix lint issues in API
 */
export interface CreateUserRoleRequest {
  roleId: string;
  clientId: string;
  projects: object[];
  permissionGroups?: string[];
}

export interface DeleteUserRoleRequest {
  clientId: string | null;
}

export interface UpdateUserRoleRequest {
  roleId: string;
  userRoleId: string;
}

export interface ClientManagementApiResult<T> {
  value?: T;
  data?: T;
}

export interface DeleteUserRoleCommandResponse {
  userRoleId: string;
}

/** Unwraps CM command write responses (`data` or `value` envelope). */
export function resolveClientManagementCommandDto<T>(
  envelope: ClientManagementApiResult<T> | T | undefined
): T | undefined {
  if (!envelope || typeof envelope !== 'object') {
    return undefined;
  }
  const wrapped = envelope as ClientManagementApiResult<T>;
  return wrapped.value ?? wrapped.data ?? (envelope as T);
}

/** Unwraps CM command DTO from full axios response (`data`, `data.value`, or root). */
export function resolveClientManagementCommandDtoFromAxios<T>(
  axiosData: unknown
): T | undefined {
  if (!axiosData || typeof axiosData !== 'object') {
    return undefined;
  }
  const body = axiosData as {data?: ClientManagementApiResult<T> | T};
  return (
    resolveClientManagementCommandDto(body.data) ??
    resolveClientManagementCommandDto(body as T)
  );
}

export interface CreatePermissionGroupRequest {
  id: string | undefined;
  name: string;
  description: string;
  clientId: string;
  permissions: string[];
}

export interface AlertReuqest {
  alertCode: string;
  isEnabled: boolean;
}

export interface PermissionGroupRequest {
  id: string | undefined;
  name: string;
  description: string;
  clientId: string;
  permissions: string[];
}

export interface AddNewOrUpdateProjectsToUserRoleReq {
  id: string;
  name: string;
  isDeleted?: boolean;
  dataCenterName?: string;
  domainCountryCode?: string;
  permissionGroupId?: string | null;
  projectPermissions?: Permission[];
  clientId?: string;
  workspaces: {
    id: string;
    name: string;
    code?: string;
    isDeleted?: boolean;
  }[];
}

export interface IProjectData {
  clientId: string;
  clientName: string;
  projectId: string;
  projectName: string;
  engagementCode: string;
  alphaCode: string;
  clientPreferredId: string;
  branchName: string;
  departmentName: string;
  domainCountryCode: string;
  highlyConfidential: boolean;
  ecaEnabled: boolean;
  hasAlerts: boolean;
  dataDeliveriesCount: number;
  dataProcessingGb: number;
  processedDatasetsGb: number;
  productionsCompletedCount: number;
  reviewWorkspaceUsersCount: number;
  totalDataUnderManagementGb: number;
  pinned: boolean;
}

export interface ICountry {
  countryCode: string;
  countryName: string;
}

export interface IFilterData {
  countries: ICountry[];
}
